'use strict';

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Modal = function () {
    function Modal(module) {
        (0, _classCallCheck3.default)(this, Modal);


        // Cache the module element.
        this.module = module;

        // Cache all the close buttons.
        this.closeBtns = this.module.querySelectorAll('.modal--close');

        // Cache all views.
        this.views = this.module.querySelectorAll('.modal--wrap');

        // Caching a reference to the body element.
        this.body = document.querySelector('body');
    }

    Modal.prototype.init = function init() {
        var _this = this;

        // Bind the close event to all close buttons.
        for (var i = 0, count = this.closeBtns.length; i < count; i++) {
            this.closeBtns[i].onclick = function () {
                return _this.close();
            };
        }

        // Binding the close event to the escape key.
        document.onkeydown = function (evt) {

            // Used to determine if the escape key was clicked.
            var isEscape = false;

            // Check the new key property first.
            if ('key' in evt) {
                isEscape = evt.key === 'Escape' || evt.key === 'Esc';
            }

            // For a fallback check the keyCode property.
            else {
                    isEscape = evt.keyCode === 27;
                }

            // Close the modal, if the escape key was clicked.
            if (isEscape) {
                _this.close();
            }
        };

        // When a user clicks off the modal, close the modal.
        document.onclick = function (e) {

            // Ensure the modal background was clicked on, then close.
            if (e.target.classList.contains('modal')) {
                _this.close();
            }
        };
    };

    Modal.prototype.close = function close() {

        // Disable the modal.
        this.module.setAttribute('aria-hidden', 'true');

        // Disable all views.
        for (var i = 0, count = this.views.length; i < count; i++) {
            this.views[i].setAttribute('aria-hidden', 'true');
        }

        // Enable scroll again.
        this.body.setAttribute('data-scrollable', 'true');

        // Load the scroll position, before the modal opened.
        var scrollPos = this.body.getAttribute('data-scroll-pos');

        // Remove the saved scroll position.
        this.body.removeAttribute('data-scroll-pos');

        // Jump the user back to where they were.
        window.scrollTo(0, scrollPos);
    };

    return Modal;
}();

var _module = document.querySelector('#modal');
if (_module !== null) {
    var modal = new Modal(_module);
    modal.init();
}


//////////////////
// WEBPACK FOOTER
// ./src/components/modal/modal.js
// module id = 3
// module chunks = 0